import { Box, HStack } from "@chakra-ui/react";
import FilterSortSearchBar from "components/ControlBar/FilterSortSearchBar";
import FilterButton from "components/Button/FilterButton";
import { MeetingType } from "features/Resources/Meeting/models";

interface MeetingsScheduleFiltersProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  activeTypes: Set<MeetingType>;
  onToggleType: (type: MeetingType) => void;
  showSkipped: boolean;
  onToggleSkipped: () => void;
}

const TYPE_CHIPS: { type: MeetingType; label: string; color: string }[] = [
  { type: "individual", label: "Individual", color: "purple.400" },
  { type: "group_session_adhoc", label: "Group One Time", color: "blue.400" },
  { type: "group_session_recurring", label: "Group Standing", color: "green.400" },
];

// Rendered inside the button's children (not FilterButton's `icon` slot, which force-recolors
// element icons to white when active — that would blank out the type-color swatch).
function ChipLabel({ color, label }: { color: string; label: string }) {
  return (
    <HStack spacing={1.5} align="center">
      <Box w="8px" h="8px" borderRadius="full" bg={color} flexShrink={0} />
      <span>{label}</span>
    </HStack>
  );
}

export default function MeetingsScheduleFilters({
  searchText,
  onSearchChange,
  activeTypes,
  onToggleType,
  showSkipped,
  onToggleSkipped,
}: MeetingsScheduleFiltersProps) {
  const quickFilters = (
    <>
      <FilterButton isActive={showSkipped} onClick={onToggleSkipped}>
        <ChipLabel color="gray.400" label="Skipped" />
      </FilterButton>
      {TYPE_CHIPS.map((chip) => (
        <FilterButton key={chip.type} isActive={activeTypes.has(chip.type)} onClick={() => onToggleType(chip.type)}>
          <ChipLabel color={chip.color} label={chip.label} />
        </FilterButton>
      ))}
    </>
  );

  return (
    <FilterSortSearchBar
      searchValue={searchText}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search meetings..."
      hideSort
      currentSort=""
      defaultSort=""
      onSortChange={() => {}}
      sortOptions={[]}
      quickFilters={quickFilters}
      activeFilters={[]}
      onReset={() => {}}
      hasActiveFilters={false}
    />
  );
}
